<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "reserveProperty",
  data() {
    return {
      contactDialogVisible: false,
      loading: false,
      rules: {
        name: {
          required: true,
          message: "Please enter your name",
          trigger: "blur"
        },
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,20}$/
        },
        phoneNumber: {
          required: true,
          message: "Please enter phone number",
          trigger: "blur"
        },
        message: {
          required: true,
          message: "Please enter message",
          trigger: "blur"
        }
      },
      form: {
        name: "",
        email: "",
        phoneNumber: "",
        message: ""
      }
    };
  },
  props: {
    listingDetails: Object
  },
  methods: {
    ...mapActions("contact", ["contact"]),
    reserveTheProperty(type) {
      // let token = localStorage.getItem('token')
      // if (!token || (token && token.length < 10)) {
      //   this.$box.alert('', 'Please login first.', 'error')
      //   return
      // }
      this.$router.push({
        path: "/property/reservation/",
        query: { pid: this.$route.query.pid, type: type?type:1 }
      });
    },
    reserveTheProperty2() {
      this.$router.push({
        path: "/property/reservation/",
        query: { pid: this.$route.query.pid, type: 2 }
      });
    },
    closeContact() {
      this.contactDialogVisible = false;
      this.form = {
        name: "",
        email: "",
        phoneNumber: "",
        message: ""
      };
      this.$refs.form.clearValidate();
    },
    onSubmit(formName) {
      var that = this;
      if (that.loading) return;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.loading) return;
          that.loading = true;
          that.contact({
            params: {
              id: that.$route.query.pid,
              data: {
                email: that.form.email,
                message: that.form.message,
                name: that.form.name,
                phone: that.form.phoneNumber
              }
            },
            callback: that.callback
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    validate(filed) {
      if (filed === "phone") {
        this.form.phoneNumber = this.form.phoneNumber.replace(/[^\d]/g, "");
      }
    },
    callback(res) {
      var that = this;
      that.loading = false;
      if (res.data.code == 0) {
        that.$box.alert("", "Successfully submitted", "success");
        that.closeContact();
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    }
  }
};
</script>

<template>
  <el-row style="background-color: #101010">
    <el-dialog
      :show-close="false"
      :visible.sync="contactDialogVisible"
      center
      custom-class="contact-dialog"
      title=""
      width="340px"
    >
      <template #title>
        <div class="contact-title">
          Contact agent
          <div class="icon" @click="closeContact">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </template>
      <div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="top"
          label-width="100px"
          @submit.native.prevent
        >
          <el-form-item label="Name" prop="name">
            <el-input
              v-model="form.name"
              maxlength="50"
              placeholder="Your name"
            ></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input
              v-model="form.email"
              maxlength="100"
              placeholder="Your email"
            ></el-input>
          </el-form-item>
          <el-form-item label="Phone number" prop="phoneNumber">
            <el-input
              v-model="form.phoneNumber"
              maxlength="20"
              placeholder="Your phone number"
              @input="validate('phone')"
            ></el-input>
          </el-form-item>
          <el-form-item label="Message" prop="message">
            <el-input
              v-model="form.message"
              maxlength="1000"
              placeholder="Message"
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align:center">
            <el-button class="submit-button" @click="onSubmit('form')"
              >Confirm
              <i v-if="loading" class="el-icon-loading"></i>
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <img
      class="background-image"
      loading="lazy"
      src="../../assets/reserve-the-property.jpg"
    />
    <el-row style="padding:21px 16px">
      <el-col :span="24" style="display: flex; justify-content: center">
        <span class="reserve-property-title">Reserve the property</span>
      </el-col>
      <el-col :span="24" style="display: flex; margin-top: 30px">
        <span class="reserve-property-desc"
          >To ensure that this property is secured, the purchaser is entitled to
          place a reservation on the property for a 7day exclusive period, free
          of competition, to seek advice and proceed with the sale.</span
        >
      </el-col>
      <el-col
        :span="24"
        style="display: flex; flex-direction: column; margin-top: 40px"
      >
        <el-button class="btn-enquire" @click="contactDialogVisible = true"
          >Contact Agent</el-button
        >
      </el-col>
      <el-col
        :span="24"
        style="display: flex; flex-direction: column; margin-top: 18px"
      >
        <el-button
          v-if="
            (listingDetails.price == 0 && listingDetails.maxPrice == 0) ||
              (!listingDetails.price && !listingDetails.maxPrice) ||
              (listingDetails.price &&
                listingDetails.price != 0 &&
                listingDetails.maxPrice &&
                listingDetails.maxPrice != 0 &&
                listingDetails.price != listingDetails.maxPrice)
          "
          class="btn-reserve"
          v-track:101.click="reserveTheProperty"
        >
          Select Now
        </el-button>
        <el-button
          v-if="
            (listingDetails.price &&
              listingDetails.price != 0 &&
              !listingDetails.maxPrice) ||
              (listingDetails.price &&
                listingDetails.price != 0 &&
                listingDetails.maxPrice == 0) ||
              (listingDetails.price &&
                listingDetails.price != 0 &&
                listingDetails.maxPrice &&
                listingDetails.maxPrice != 0 &&
                listingDetails.price == listingDetails.maxPrice)
          "
          class="btn-reserve"
          v-track:101.click="reserveTheProperty2"
        >
          Select Now
        </el-button>
      </el-col>
    </el-row>
  </el-row>
</template>

<style scoped>
.background-image {
  position: absolute;
  opacity: 0.7;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.reserve-property-title {
  color: #f5f5f5;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  align-self: stretch;
  font-family: Metropolis;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 117.647%;
}

.reserve-property-desc {
  color: #f5f5f5;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  align-self: stretch;
  font-family: Metropolis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
}

.btn-enquire {
  color: #ffbe00;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  padding: 14px 32px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  border: 3px solid #ffbe00;
  background: #2d2d2d;
}

.btn-reserve {
  display: flex;
  padding: 14px 32px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background: #2cca73;
  color: #101010;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.contact-title {
  text-align: left;
  font-size: 22px;
  font-family: Metropolis, sans-serif;
  font-weight: 600;
  margin-bottom: 10px;
}

.contact-title .icon {
  float: right;
  width: 35px;
  height: 35px;
  font-size: 35px;
  cursor: pointer;
  color: #aaaaaa;
  position: relative;
  top: -15px;
  right: -10px;
}

.submit-button {
  width: 200px;
  height: 50px;
  color: #ffbe00 !important;
  text-align: center;
  border-radius: 5px;
  border: 3px solid #ffbe00 !important;
  background-color: #2d2d2d !important;
  font: 600 20px Metropolis, sans-serif;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/reserveProperty.vue